require('./common-header.jade')
sampleUserAvatar = require('../../../../images/sample-user-avatar.png')
$ = require('jquery')
ICON_USER = '.user'
MENU_TOOLTIP = '.tooltip-help2'


CommonHeaderDirective = ($location, AuthService, AccountService, $filter) ->
  restrict: "A"
  replace: false
  templateUrl: "components/common-header/common-header.jade"
  controller: ['$scope', ($scope) ->
    $scope.hasAcceptedTerms = false
    @includeNavigation = (showNavigation) ->
      $scope.showNavigation = showNavigation
    return
  ]
  link: (scope) ->
    scope.sampleUserAvatar = sampleUserAvatar
    scope.isSignedIn = AuthService.isSignedIn()
    scope.userInfo = undefined
    scope.showMenu = false
    scope.admin = false
    scope.smallMenu = false
    scope.toggleMenu = ->
      scope.showMenu = !scope.showMenu

    scope.showSmallMenu = ->
      scope.smallMenu = !scope.smallMenu
      if scope.smallMenu
        itemFade = '<div id="fadeBackground" '
        itemFade += 'style = "top: 0; left: 0; '
        itemFade += 'position : absolute ; background-color:white; opacity : 0.6 ; z-index: 100; '
        itemFade += 'width: ' + $(document).width() + "px ; "
        itemFade += 'height: ' + $(document).height() + "px ; "
        itemFade += '" ></div>'
        $( "body" ).append(itemFade)
        $( "body" ).css("overflow" , "hidden")
        return true
      else
        $( "#fadeBackground" ).remove()
        $( "body" ).css("overflow" , "auto")
        return true

    scope.signOut = ->
      AuthService.signOut()
    scope.editAccount = ->
      $location.path("/registration/edit")
    scope.getFullName = ->
      (if scope.userInfo then scope.userInfo?.name else "")
    scope.getUserId = ->
      (if scope.userInfo then ('?user_id=' + scope.userInfo?.user_id) else "")

    scope.submitTerms = ->
      AccountService.acceptTerms().then (data) ->
        scope.hasAcceptedTerms = false
        $('#terms_of_use-modal').modal('hide')



    scope.getTextOfAvatar = ->
      return unless scope.userInfo
      $(document).ready ->
        $avatarElement = $(".avatar-for-#{scope.userInfo.user_id} .avatar-image-text:not(.is-small)")

        if scope.userInfo.display_text_avatar?.length == 1
          $avatarElement.removeClass('two-characters')
          $avatarElement.addClass('one-character')
        else
          $avatarElement.removeClass('one-character')
          $avatarElement.addClass('two-characters')
          $(".avatar-image-text.is-small").addClass('two-characters')
      scope.userInfo.display_text_avatar

    scope.isAvatarColor = ->
      return unless scope.userInfo
      scope.userInfo.avatar_image_path?.indexOf('avatar_color') > -1

    # update userInfo when user enter a page
    if scope.isSignedIn
      AccountService.getUserInfo().then (data) ->
        scope.userInfo = data
        if !data.has_accept_terms_of_use
          $('#terms_of_use-modal').modal
            backdrop: 'static'
            keyboard: false
            show: true
        scope.admin = data.admin
        # call check if user is confirmed or not to show the warning message
        unless data.email_confirmed
          AccountService.showConfirmationWarning(data.email)

    scope.$on "accountLoaded.gnp.AccountService", (e, userInfo) ->
      scope.userInfo = userInfo

    isMenuElement = ($target) ->
      $target.is(ICON_USER) or
        $target.parents(MENU_TOOLTIP).length or
        $target.is(MENU_TOOLTIP)

    scope.$on '$destroy', ->
      $( "#fadeBackground" ).remove()
      $( "body" ).css("overflow" , "auto")
      scope.showMenu = false

    angular.element(window).bind('resize', ->
      if window.innerWidth > 768
        $( "#fadeBackground" ).remove()
        $( "body" ).css("overflow" , "auto")
        scope.$apply ->
          scope.smallMenu = false
    )

    angular.element(document).ready ->
      document.body.scrollTop = document.documentElement.scrollTop = 0

    if localStorage.getItem("TRANSITION_FROM_ANALYSIS")
      currentPath = $location.absUrl()
      if currentPath.indexOf('/analysis') == -1 && currentPath.indexOf('/round-detail') == -1
        localStorage.removeItem("TRANSITION_FROM_ANALYSIS")

CommonHeaderDirective.$inject = [
  "$location"
  "AuthService"
  "AccountService"
  "$filter"
]

module.exports = CommonHeaderDirective



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/common-header/common-header-directive.coffee